export const version = "units/5.0.10";
//# sourceMappingURL=_version.js.map